import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalCartService {
  private storageKey = 'user_cart_items';

  getProducts() {
    let products = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
    return products;
  }

  getProductKey(product: any): string {
    return `${product.atc_product_id}-${product.atc_brand_id}-${product.atc_model_id}-${product.atc_color_str}`;
  }

  addProduct(product: any) {
    let products = this.getProducts();
    const key = this.getProductKey(product);
    let productValue = {
      atc_product_id: product.atc_product_id,
      atc_brand_id: product.atc_brand_id,
      atc_model_id: product.atc_model_id,
      atc_color_str: product.atc_color_str,
      qty: (!products[key]?.qty) ? 1 : products[key].qty + 1
    };
    products[key] = productValue;
    localStorage.setItem(this.storageKey, JSON.stringify(products));
  }

  incrementQty(product: any): boolean {
    let products = this.getProducts();
    const key = this.getProductKey(product);
    if (products[key]) {
      products[key].qty = (products[key].qty || 1) + 1;
      localStorage.setItem(this.storageKey, JSON.stringify(products));
      return true;
    }
    return false;
  }

  decrementQty(product: any): boolean {
    let products = this.getProducts();
    const key = this.getProductKey(product);
    if (products[key] && products[key].qty > 1) {
      products[key].qty--;
      localStorage.setItem(this.storageKey, JSON.stringify(products));
      return true;
    }
    return false;
  }

  removeProduct(product: any): boolean {
    let products = this.getProducts();
    const key = this.getProductKey(product);
    if (products[key]) {
      delete products[key];
      localStorage.setItem(this.storageKey, JSON.stringify(products));
      return true;
    }
    return false;
  }

  clearProducts() {
    localStorage.removeItem(this.storageKey);
  }
}
